var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { map, debounceTime, distinctUntilChanged, merge, switchMap, } from "rxjs/operators";
import { OnDestroy, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { combineLatest, Subject } from "rxjs";
import { BrowsingService } from "../../services/browsing.service";
import { FacetingService } from "../../services/faceting.service";
import { GTMService } from "../../services/gtm.service";
import { SearchingService } from "../../services/searching.service";
var ExternalSearchInputComponent = /** @class */ (function () {
    function ExternalSearchInputComponent(searchingService, browsingService, facetingService, gtmService, route, router) {
        var _this = this;
        this.searchingService = searchingService;
        this.browsingService = browsingService;
        this.facetingService = facetingService;
        this.gtmService = gtmService;
        this.route = route;
        this.router = router;
        this.$focus = new Subject();
        this.$click = new Subject();
        this.placeholder = "";
        this.buttonText = ""; // if left empty there will be no button, it will show only the icon
        this.type = "for-browse"; // for-header, for-browse depending on type it will add another style
        this.disableAutocomplete = false;
        this._pressedEnter = false;
        this.subscriptions = [];
        this.onAutocomplete = function ($text) {
            return $text.pipe(debounceTime(300), distinctUntilChanged(), merge(_this.$focus), merge(_this.$click), switchMap(function (term) { return _this.prepareAutocompleteResults(term); }));
        };
        this.formatMatches = function (value) { return value.title || ""; };
    }
    ExternalSearchInputComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscriptions.push(this.route.queryParams.subscribe(function (queryParams) {
            if (queryParams.hasOwnProperty("q")) {
                setTimeout(function () {
                    _this.form.setValue({ q: queryParams.q });
                });
            }
        }));
    };
    ExternalSearchInputComponent.prototype.onSearch = function (form) {
        var queryParams = form.value;
        this.router.navigate(["search"], { queryParams: queryParams });
        this._pressedEnter = true;
        this.gtmService.pushEvent("external-search");
    };
    ExternalSearchInputComponent.prototype.resetPressedEnter = function (term) {
        if (term.length !== 0) {
            this._pressedEnter = false;
        }
    };
    ExternalSearchInputComponent.prototype.onSelectItem = function (form, event) {
        var queryParams = { q: event.item.title, selected_facet: [] };
        if (event.item.subject) {
            queryParams.selected_facet.push(this.facetingService.makeSubjectQueryParam(event.item.subject.id));
        }
        if (event.item.grade) {
            queryParams.selected_facet.push(this.facetingService.makeGradeQueryParam(event.item.grade));
        }
        this.router.navigate(["search"], { queryParams: queryParams });
        var eventName = form.value.q === event.item.title
            ? "external-search-enter"
            : "search-autocomplete";
        this.gtmService.pushEvent(eventName);
    };
    ExternalSearchInputComponent.prototype.prepareAutocompleteResults = function (term) {
        var _this = this;
        if (this.disableAutocomplete)
            return [];
        return combineLatest(this.searchingService.getAutocompleteResults(term), this.browsingService.autocompleteSubjects).pipe(map(function (data) {
            if (_this._pressedEnter) {
                return [];
            }
            var response = data[0];
            var suggestions = [];
            suggestions = suggestions.concat(_this.getSmartSuggestions(term, data[1]));
            if (response.length) {
                var responses = response.objects.map(function (result) { return (__assign({}, result, { displayTitle: result.title })); });
                suggestions = suggestions.concat(responses);
            }
            return suggestions;
        }));
    };
    ExternalSearchInputComponent.prototype.removeFromTitle = function (part, title) {
        var cleanedTitle = title.replace(part, "").replace(/\s\s+/g, " ");
        if (!cleanedTitle.length) {
            return cleanedTitle;
        }
        if (cleanedTitle[0] == " ") {
            cleanedTitle = cleanedTitle.slice(1);
        }
        if (cleanedTitle[cleanedTitle.length - 1] == " ") {
            cleanedTitle = cleanedTitle.slice(0, -1);
        }
        return cleanedTitle;
    };
    ExternalSearchInputComponent.prototype.getGradeSuggestion = function (searchPhrase) {
        var suggestedGrade = null;
        var prekMatch = /(\s|^)(prek)(\s|$)/i.exec(searchPhrase);
        if (prekMatch) {
            searchPhrase = this.removeFromTitle(prekMatch[2], searchPhrase);
            return ["PreK", searchPhrase];
        }
        var kMatch = /(\s|^)(k( grade|)|kindergarten)(\s|$)/i.exec(searchPhrase);
        if (kMatch) {
            searchPhrase = this.removeFromTitle(kMatch[2], searchPhrase);
            return ["K", searchPhrase];
        }
        var plusMatch = /(\s|^)(13\+(th|)( grade|))(\s|$)/i.exec(searchPhrase);
        if (plusMatch) {
            searchPhrase = this.removeFromTitle(plusMatch[2], searchPhrase);
            return ["13+", searchPhrase];
        }
        var gradeMatch = /(\s|^)((\d)(th|nd|rd|st|)( grade|))(\s|$)/i.exec(searchPhrase);
        if (gradeMatch) {
            var grade = +gradeMatch[3];
            if (grade >= 1 && grade <= 13) {
                suggestedGrade = grade;
                searchPhrase = this.removeFromTitle(gradeMatch[2], searchPhrase);
            }
        }
        return [suggestedGrade, searchPhrase];
    };
    ExternalSearchInputComponent.prototype.getSmartSuggestions = function (searchPhrase, nodesByTitle) {
        var _this = this;
        var gradeData = this.getGradeSuggestion(searchPhrase);
        var gradeSuggestion = gradeData[0];
        searchPhrase = gradeData[1];
        var terms = searchPhrase.split(" ");
        if (terms.length < 1) {
            return [];
        }
        var suggestions = [];
        if (gradeSuggestion) {
            suggestions.push({
                displayTitle: searchPhrase,
                title: searchPhrase,
                grade: gradeSuggestion,
            });
        }
        terms.forEach(function (term) {
            var cleanedTerm = term.toLowerCase();
            if (cleanedTerm in nodesByTitle) {
                var title = _this.removeFromTitle(term, searchPhrase);
                suggestions.push({
                    displayTitle: title ? title : "All",
                    title: title,
                    subject: nodesByTitle[cleanedTerm],
                    grade: gradeSuggestion,
                });
            }
        });
        if (suggestions.length > 0) {
            suggestions[suggestions.length - 1].isLastSmart = true;
        }
        return suggestions;
    };
    ExternalSearchInputComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.map(function (subscription) { return subscription.unsubscribe(); });
    };
    return ExternalSearchInputComponent;
}());
export { ExternalSearchInputComponent };
